import { Alert, AlertType } from "@/atoms-react/alert/index.react.tsx";
import { Button } from "@/atoms-react/button/Button.react";
import { Modal, ModalContent } from "@/atoms-react/modal/index.react";
import { Routes } from "@/features/router.ts";
import { Themes } from "@/types/theme.ts";
import { ChatBubbleOvalLeftEllipsisIcon } from "@heroicons/react/20/solid";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export const ModalUpdateInfoHelper = ({ ...props }) => {
  const { t } = useTranslation(["pass"], { useSuspense: false });
  const navigate = useNavigate();
  return (
    <Modal {...props} maxWidthClassName="max-w-lg">
      <ModalContent title={t("olkypass.accountPage.basicInfo.helper.header")}>
        <div className={"flex flex-col opacity-1"}>
          <div className={"my-6 w-full"}>
            <Alert type={AlertType.Warning} title="">
              <span className="font-medium text-sm">
                {t("olkypass.accountPage.basicInfo.helper.text")}
              </span>
            </Alert>
          </div>
          <Button
            className="mt-2 w-full shrink-0"
            theme={Themes.white}
            onClick={() => navigate(Routes.support)}
            icon={<ChatBubbleOvalLeftEllipsisIcon />}
          >
            {t("olkypass.accountPage.basicInfo.helper.button")}
          </Button>
        </div>
      </ModalContent>
    </Modal>
  );
};
